import type { TrashResult } from "./types";
import { SectionCard } from "./SectionCard";

type Props = {
  trashLoading: boolean;
  trashResults: TrashResult[];
  confirmPurgeSlug: string | null;
  deleteWorking: boolean;
  onLoadTrash: () => void;
  onConfirmPurge: (slug: string | null) => void;
  onPurge: (slug: string) => void;
};

export function KbTrashSection(props: Props) {
  return (
    <SectionCard title="Trash" description="Articles moved to trash. Restore by editing them back to draft, or permanently delete to remove from the database.">
      <div className="space-y-3">
        <div className="flex gap-2">
          <button type="button" className="rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm disabled:opacity-50 dark:border-zinc-600 dark:bg-zinc-800 dark:text-zinc-200" onClick={props.onLoadTrash} disabled={props.trashLoading}>
            {props.trashLoading ? "Loading…" : "Refresh"}
          </button>
        </div>
        {props.trashResults.length === 0 && !props.trashLoading ? (
          <div className="rounded-xl border border-dashed border-gray-300 bg-gray-50 px-4 py-6 text-sm text-gray-500 dark:border-zinc-600 dark:bg-zinc-900/40 dark:text-zinc-400">Trash is empty.</div>
        ) : null}
        <div className="space-y-2">
          {props.trashResults.map((item) => (
            <div key={item.id} className="rounded-xl border border-red-200 bg-red-50 px-3 py-3 dark:border-red-900 dark:bg-red-950/35">
              {props.confirmPurgeSlug === item.slug ? (
                <div className="flex flex-wrap items-center gap-2 text-xs text-red-900 dark:text-red-200">
                  <span className="font-medium">Permanently delete "{item.title}"? This cannot be undone.</span>
                  <button type="button" className="rounded-lg border border-red-600 bg-red-100 px-2 py-1 font-semibold text-red-900 disabled:opacity-50 dark:border-red-700 dark:bg-red-950/50 dark:text-red-100" onClick={() => props.onPurge(item.slug)} disabled={props.deleteWorking}>
                    {props.deleteWorking ? "Deleting…" : "Permanently delete"}
                  </button>
                  <button type="button" className="rounded-lg border border-gray-300 bg-white px-2 py-1 text-gray-700 dark:border-zinc-600 dark:bg-zinc-800 dark:text-zinc-200" onClick={() => props.onConfirmPurge(null)}>
                    Cancel
                  </button>
                </div>
              ) : (
                <div className="flex items-start justify-between gap-3">
                  <div>
                    <div className="text-sm font-medium text-gray-900 dark:text-zinc-100">{item.title}</div>
                    <div className="text-xs text-gray-500 mt-1 dark:text-zinc-400">{item.slug}</div>
                    <div className="mt-1 text-xs text-gray-500 dark:text-zinc-400">
                      {item.scope ?? "(no scope)"} • {item.doc_type ?? "(no type)"} • edited by {item.last_edited_by ?? "unknown"}
                    </div>
                    {item.deleted_at ? (
                      <div className="mt-1 text-xs text-red-600 dark:text-red-400">Deleted {new Date(item.deleted_at).toLocaleDateString()}</div>
                    ) : null}
                  </div>
                  <button
                    type="button"
                    className="shrink-0 rounded-lg border border-red-400 bg-white px-3 py-1.5 text-xs font-semibold text-red-700 hover:bg-red-100 disabled:opacity-50 dark:border-red-700 dark:bg-red-950/40 dark:text-red-300 dark:hover:bg-red-950/60"
                    onClick={() => props.onConfirmPurge(item.slug)}
                    disabled={props.deleteWorking}
                  >
                    Purge
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </SectionCard>
  );
}